/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';

import s from './BundleLoader.styl';
const cx = classnames.bind(s);

/**
 * BundleLoader is displayed while any given component is being loaded by
 * webpack. It is often displayed only briefly.
 *
 * Since it might appear to simply flash on screen for very breif loads it will
 * only show up after a certain timeout has passed.
 *
 * NOTE: This file is of course NOT lazily loaded, so imported dependencies
 * should be kept as minimal as possible. React doesn't count since it will
 * already be loaded by the entry point.
 */

export default class BundleLoader extends React.PureComponent {
  state = {
    show: false,
  };

  timeout: ?number;

  componentDidMount() {
    this.timeout = setTimeout(this.show, 400);
  }

  componentWillUnmount() {
    this.timeout && clearTimeout(this.timeout);
  }

  show = () => {
    this.setState(() => ({ show: true }));
  };

  render() {
    return (
      <div className={cx('BundleLoader', { show: this.state.show })}>
        <div className={cx('pulse-1')}></div>
        <div className={cx('pulse-2')}></div>
        <div className={cx('pulse-3')}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/BundleLoader.js